var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperateAc5Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8361_1337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.18071 2.34488C9.21642 2.15372 9.31786 1.98106 9.46746 1.85681C9.61706 1.73256 9.80541 1.66455 9.99988 1.66455C10.1943 1.66455 10.3827 1.73256 10.5323 1.85681C10.6819 1.98106 10.7833 2.15372 10.819 2.34488L11.6949 6.97655C11.7571 7.30584 11.9171 7.60873 12.1541 7.84569C12.391 8.08265 12.6939 8.24267 13.0232 8.30488L17.6549 9.18071C17.846 9.21642 18.0187 9.31786 18.1429 9.46746C18.2672 9.61706 18.3352 9.80541 18.3352 9.99988C18.3352 10.1943 18.2672 10.3827 18.1429 10.5323C18.0187 10.6819 17.846 10.7833 17.6549 10.819L13.0232 11.6949C12.6939 11.7571 12.391 11.9171 12.1541 12.1541C11.9171 12.391 11.7571 12.6939 11.6949 13.0232L10.819 17.6549C10.7833 17.846 10.6819 18.0187 10.5323 18.1429C10.3827 18.2672 10.1943 18.3352 9.99988 18.3352C9.80541 18.3352 9.61706 18.2672 9.46746 18.1429C9.31786 18.0187 9.21642 17.846 9.18071 17.6549L8.30488 13.0232C8.24267 12.6939 8.08265 12.391 7.84569 12.1541C7.60873 11.9171 7.30584 11.7571 6.97655 11.6949L2.34488 10.819C2.15372 10.7833 1.98106 10.6819 1.85681 10.5323C1.73256 10.3827 1.66455 10.1943 1.66455 9.99988C1.66455 9.80541 1.73256 9.61706 1.85681 9.46746C1.98106 9.31786 2.15372 9.21642 2.34488 9.18071L6.97655 8.30488C7.30584 8.24267 7.60873 8.08265 7.84569 7.84569C8.08265 7.60873 8.24267 7.30584 8.30488 6.97655L9.18071 2.34488Z",
    stroke: "#00A63E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 1.6665V4.99984",
    stroke: "#00A63E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 3.3335H15",
    stroke: "#00A63E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33317 18.3333C4.25365 18.3333 4.99984 17.5871 4.99984 16.6667C4.99984 15.7462 4.25365 15 3.33317 15C2.4127 15 1.6665 15.7462 1.6665 16.6667C1.6665 17.5871 2.4127 18.3333 3.33317 18.3333Z",
    stroke: "#00A63E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8361_1337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperateAc5Icon);
export default __webpack_public_path__ + "static/media/operate_ac_5_icon.4eacf2c5da418d5209fd260f20bb1762.svg";
export { ForwardRef as ReactComponent };